import { translateText } from "../../../helpers/LanguageHelper";
import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Row, Col } from "reactstrap";
import ProductBox from "./ProductBox";
import Skeleton from "./Skeleton/Skeleton";

import { getLanguageCodeFromSession, GetLocalizationControlsJsonDataForScreen } from "../../../helpers/CommonHelper";
import Config from "../../../helpers/Config";
import { MakeApiCallAsync } from "../../../helpers/ApiHelpers";
import GlobalEnums from "../../../helpers/GlobalEnums";



const NewProducts = ({ effect }) => {
    const firstProductId = 1058;
    const [activeTab, setActiveTab] = useState("best sellers");
    const [collection, setCollection] = useState([
        {
            nameEn: "new products",
            icon: "fa-star",
            caption: "Fresh arrivals",
            nameAr: "منتجات جديدة"
        },
        {
            nameEn: "best sellers",
            displayName: "fast moving",
            icon: "fa-trophy",
            caption: "Selling quickly",
            nameAr: "أفضل البائعين"
        },
        {
            nameEn: "on sale",
            icon: "fa-tag",
            caption: "Save more",
            nameAr: "للبيع"
        },
        {
            nameEn: "hotdeal",
            icon: "fa-fire",
            caption: "Limited offers",
            nameAr: "صفقة حاسمة"
        }
        

    ]);

    const [ProductsList, setProductsList] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);
    const [langCode, setLangCode] = useState('');
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);
    const [PaginationInfo, setPaginationInfo] = useState({
        PageNo: 1,
        PageSize: 20,
        TotalRecords: 0
    });



    const getNewProductsList = async (TabName) => {

        setActiveTab(TabName);
        setProductsLoading(true);

        const headers = {

            Accept: 'application/json',
            'Content-Type': 'application/json',

        }


        const catalogParam = {
            requestParameters: {
                SearchTerm: null,
                SizeID: "",
                ColorID: null,
                CategoryID: "",
                TagID: "",
                ManufacturerID: "",
                MinPrice: null,
                MaxPrice: null,
                Rating: null,
                OrderByColumnName: "",
                PageNo: 1,
                PageSize: 10,
                recordValueJson: "[]",
            },
        };

        const showProducts = (products) => {
            setProductsList(previousProducts => {
                const byId = new Map();
                [...previousProducts, ...products].forEach(product => {
                    const id = Number(product.ProductId ?? product.ProductID);
                    if (id >= firstProductId && id !== 1063) byId.set(id, { ...product, ProductId: id });
                });
                return [...byId.values()].sort((first, second) => first.ProductId - second.ProductId);
            });
        };
        const catalogRequest = MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_PRODUCTS'], null, catalogParam, { ...headers }, "POST", true);
        const knownProductsRequest = MakeApiCallAsync(Config.END_POINT_NAMES['GET_PRODUCTS_LIST_BY_IDS'], null, {
            requestParameters: {
                ProductsIds: JSON.stringify([1058, 1059, 1060, 1061, 1062, 1064, 1065, 1066].map(ProductId => ({ ProductId }))),
                recordValueJson: "[]",
            },
        }, { ...headers }, "POST", true);
        const comboSearchRequest = MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_PRODUCTS'], null, {
            requestParameters: { ...catalogParam.requestParameters, SearchTerm: "Uthukuli Cow Signature Combo" },
        }, { ...headers }, "POST", true);
        try {
            const response = await knownProductsRequest;
            const products = JSON.parse(response?.data?.data || "[]");
            if (Array.isArray(products) && products.length > 0) {
                showProducts(products);
                setProductsLoading(false);
            }
        } catch (error) {
            console.error("Could not read the known products", error);
        }
        try {
            const response = await comboSearchRequest;
            const products = JSON.parse(response?.data?.data || "[]");
            if (Array.isArray(products) && products.length > 0) {
                showProducts(products);
                setProductsLoading(false);
            }
        } catch (error) {
            console.error("Could not find the combo product", error);
        }
        let recentProducts = [];
        try {
            const response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_RECENTS_PRODUCTS_LIST'], null, {
                requestParameters: {
                    PageNo: 1,
                    PageSize: 20,
                    TabName: "new products",
                    recordValueJson: "[]",
                },
            }, { ...headers }, "POST", true);
            const products = JSON.parse(response?.data?.data || "[]");
            if (Array.isArray(products)) {
                recentProducts = products;
                if (products.length > 0) {
                    showProducts(products);
                    setProductsLoading(false);
                }
            }
        } catch (error) {
            console.error("Could not read newly added products", error);
        }

        let catalogLoaded = false;
        try {
            const response = await catalogRequest;
            const products = JSON.parse(response?.data?.data || "[]");
            if (Array.isArray(products) && products.length > 0) {
                catalogLoaded = true;
                showProducts([...recentProducts, ...products]);
                setProductsLoading(false);
                const totalRecords = Number(products[0]?.TotalRecords) || products.length;
                const pageCount = Math.ceil(totalRecords / catalogParam.requestParameters.PageSize);
                if (pageCount > 1) {
                    const remainingPages = await Promise.all(Array.from({ length: pageCount - 1 }, (_, index) =>
                        MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_PRODUCTS'], null, {
                            requestParameters: { ...catalogParam.requestParameters, PageNo: index + 2 },
                        }, { ...headers }, "POST", true)));
                    const remainingProducts = remainingPages.flatMap(page => {
                        try {
                            const parsed = JSON.parse(page?.data?.data || "[]");
                            return Array.isArray(parsed) ? parsed : [];
                        } catch (error) {
                            console.error("Could not read a product catalog page", error);
                            return [];
                        }
                    });
                    showProducts([...recentProducts, ...products, ...remainingProducts]);
                }
            }
        } catch (error) {
            console.error("Could not read the product catalog", error);
        } finally {
            if (catalogLoaded || recentProducts.length > 0) setProductsLoading(false);
        }

        if (!catalogLoaded && recentProducts.length === 0) setProductsLoading(false);
    }



    useEffect(() => {
        // declare the data fetching function
        const dataOperationInUseEffect = async () => {

            //--Get language code
            let lnCode = getLanguageCodeFromSession();
            await setLangCode(lnCode);


            await getNewProductsList("new products");
            //-- Get website localization data
            let arryRespLocalization = await GetLocalizationControlsJsonDataForScreen(GlobalEnums.Entities["NewProducts"], null);
            if (arryRespLocalization != null && arryRespLocalization != undefined && arryRespLocalization.length > 0) {
                await setLocalizationLabelsArray(arryRespLocalization);
            }





        }

        // call the function
        dataOperationInUseEffect().catch(console.error);

    }, [])



    return (
        <>

            <section className="section-pt-space ukl-new-products-tabs">
                <div className="tab-product-main">
                    <div className="tab-prodcut-contain">
                        <div className="ukl-our-products-title">
                            <span className="ukl-our-products-title__icon"><i className="fa fa-shopping-basket" /></span>
                            <div>
                                <h2>{translateText("Our Products")}</h2>
                                <p>{translateText("Fresh Uthukuli favourites, selected for you")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-py-space ratio_asos product ukl-new-products-grid">
                <div className="custom-container">
                    <Row>
                        <Col className="pe-0">
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={activeTab}>

                                    {productsLoading ? (
                                        <Skeleton />
                                    ) : ProductsList.length === 0 ? (
                                        <p className="text-center">{translateText("No products available")}</p>
                                    ) : (
                                        <>
                                            <div className="product product-grid-vertical product-m">
                                                <Row className="ukl-product-row">
                                                    {ProductsList && ProductsList.map((itm, i) => (
                                                        <Col xs="6" md="4" lg="3" xl="3" key={i} className="ukl-product-column">
                                                            <ProductBox
                                                                hoverEffect={effect}
                                                                item={itm}
                                                                layout=""
                                                                ProductDetailPageForceUpload={false}
                                                                fitImage={true}
                                                            />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </>
                                    )}

                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default NewProducts;
